import { POSTHOG_EU_HOST, POSTHOG_PROJECT_TOKENS, getIdPrefix } from './config'
import { readPostHogDevOverride } from './dev-override'

export interface PostHogSettings {
  token: string
  apiHost: string
  /** `false` only for the local dev override with `skipConsent`, never in production. */
  requiresConsent: boolean
  idPrefix: string
}

/**
 * Decides whether PostHog may run at all in this build and with which project.
 *
 * - production: the product's EU Cloud project, gated by Usercentrics consent
 * - everything else: only with an explicit developer override, otherwise `null`
 */
export const resolvePostHogSettings = (): PostHogSettings | null => {
  const idPrefix = getIdPrefix(ENV.product, ENV.releaseStage)

  if (ENV.releaseStage === 'production') {
    const token = POSTHOG_PROJECT_TOKENS[ENV.product]
    if (!token) {
      return null
    }
    return { token, apiHost: POSTHOG_EU_HOST, requiresConsent: true, idPrefix }
  }

  const override = readPostHogDevOverride()
  if (!override) {
    return null
  }
  return {
    token: override.token,
    apiHost: override.host ?? POSTHOG_EU_HOST,
    requiresConsent: !override.skipConsent,
    idPrefix,
  }
}
